<template>
  <div>
    <v-card>
      <v-card-title>
        <v-layout row wrap align-center>
          <v-flex sm6 xs12 d-flex>
            <v-toolbar flat color="white">
              <v-toolbar-title>Hotel List</v-toolbar-title>
              <v-divider class="mr-2 ml-4" inset vertical></v-divider>
              <v-btn color="primary" fab dark @click="openCreateDialog">
                <v-icon color="black">add</v-icon>
              </v-btn>
            </v-toolbar>
          </v-flex>
          <v-flex sm6 xs12 d-flex>
            <v-layout row wrap>
              <v-flex xs12 d-flex>
                <v-text-field
                  v-model="search"
                  prepend-icon="search"
                  label="Search by Hotel Name, Email, or Telephone"
                  single-line
                  hide-details
                  style="width: 100%"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :loading="loadingMessage"
        :items="filteredHotelList"
        :pagination.sync="pagination"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">{{ props.index + 1 }}</td>
          <td class="text-xs-center">{{ props.item.name }}</td>
          <td class="text-xs-center">{{ props.item.description }}</td>
          <td class="text-xs-center">{{ props.item.star_rating }}</td>
          <td class="text-xs-center">{{ props.item.contact_email }}</td>
          <td class="text-xs-center">{{ props.item.contact_phone }}</td>
          <td class="text-xs-center">
            <v-switch
              hide-details
              color="primary"
              v-model="props.item.is_active"
              @change="changeHotelStatus(props.item)"
            ></v-switch>
          </td>
          <td class="text-xs-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click="openCommissionDialog(props.item)"
                >
                  <v-icon small>monetization_on</v-icon>
                </v-btn>
              </template>
              <span>Set Commission</span>
            </v-tooltip>
            <v-btn icon @click="openEditDialog(props.item)">
              <v-icon small>edit</v-icon>
            </v-btn>
          </td>
        </template>
        <template v-slot:no-data>
          <v-layout v-if="loadingMessage" align-center justify-center>
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-layout>
        </template>
      </v-data-table>
      <v-snackbar v-model="errSnackbar" color="black" :timeout="3000">
        {{ snackBarMsg || "มีบางอย่างผิดพลาด!" }}
        <v-btn dark flat @click="errSnackbar = false"> Close </v-btn>
      </v-snackbar>
    </v-card>
    <createHotelFormDialog
      :dialog="createDialog"
      @close="createDialog = false"
      @save="doCreateHotel"
    />
    <editHotelFormDialog
      :dialog="editDialog"
      :hotelData="selectedHotel"
      @close="editDialog = false"
      @updateInfo="doUpdateHotelInfo"
      @updateLocation="doUpdateHotelLocation"
      @updateAppStyle="doUpdateAppStyle"
    />
    <setHotelComissionDialog
      :dialog="setComissionDialog"
      @close="setComissionDialog = false"
      :hotelData="selectedHotel"
    ></setHotelComissionDialog>
    <v-dialog v-model="deleteDialog" max-width="500px" persistent>
      <v-card style="border-radius: 10px">
        <v-toolbar
          dark
          style="background-color: #fddf00; color: black"
          class="elevation-0"
        >
          <v-toolbar-title>
            <h4>Confirm Delete</h4>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon @click="deleteDialog = false" color="black" size="30"
            >close</v-icon
          >
        </v-toolbar>
        <v-card-text style="height: auto" class="px-4 pt-4">
          Are you sure you want to delete this hotel?
        </v-card-text>
        <v-card-actions style="padding-bottom: 30px" class="pr-4">
          <v-spacer></v-spacer>
          <v-btn
            color="black"
            style="
              width: 120px;
              background: #000000;
              box-shadow: 0px 3px 6px #00000029;
              border-radius: 7px;
              font-weight: bold;
              letter-spacing: 0.1rem;
              color: white;
            "
            @click="deleteDialog = false"
            :disabled="isDeleting"
          >
            Cancel
          </v-btn>
          <v-btn
            color="red"
            style="
              width: 120px;
              background: #000000;
              box-shadow: 0px 3px 6px #00000029;
              border-radius: 7px;
              font-weight: bold;
              letter-spacing: 0.1rem;
              color: white;
            "
            @click="deleteHotelItem"
            :loading="isDeleting"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
import createHotelFormDialog from "@/components/back-office/HotelServices/CreateHotelFormDialog.vue";
import editHotelFormDialog from "@/components/back-office/HotelServices/EditHotelFormDialog.vue";
import setHotelComissionDialog from "@/components/back-office/HotelServices/SetHotelComissionDialog.vue";
export default {
  components: {
    createHotelFormDialog,
    editHotelFormDialog,
    setHotelComissionDialog,
  },
  props: ["searchLog"],
  data() {
    return {
      search: "",
      loadingMessage: false,
      pagination: {
        rowsPerPage: 10,
      },
      headers: [
        { text: "No", sortable: false, align: "center" },
        { text: "Hotel Name", value: "name", sortable: false, align: "center" },
        {
          text: "Description",
          value: "description",
          sortable: false,
          align: "center",
        },
        {
          text: "Star Rating",
          value: "star_rating",
          sortable: false,
          align: "center",
        },
        {
          text: "Email",
          value: "contact_email",
          sortable: false,
          align: "center",
        },
        {
          text: "Phone",
          value: "contact_phone",
          sortable: false,
          align: "center",
        },
        {
          text: "Status",
          value: "is_active",
          sortable: false,
          align: "center",
        },
        { text: "Action", sortable: false, align: "center" },
      ],
      errSnackbar: false,
      snackBarMsg: null,
      data_loading: false,
      createDialog: false,
      editDialog: false,
      selectedHotel: {},
      deleteDialog: false,
      hotelToDelete: null,
      isDeleting: false,
      setComissionDialog: false,
    };
  },
  watch: {
    searchLog() {
      this.search = this.searchLog.status;
    },
  },
  computed: {
    ...mapState({
      hotelListData: (state) => state.hotel.hotelListData,
    }),
    filteredHotelList() {
      const order = [1, 2, 3, 5, 4];
      return this.hotelListData
        .filter((item) => {
          const searchLower = this.search.toLowerCase();
          return (
            item.name.toLowerCase().includes(searchLower) ||
            item.contact_email.toLowerCase().includes(searchLower) ||
            item.contact_phone.toLowerCase().includes(searchLower)
          );
        })
        .sort(
          (a, b) =>
            order.indexOf(a.company_provider_wesmart_status) -
            order.indexOf(b.company_provider_wesmart_status)
        );
    },
  },
  methods: {
    ...mapActions({
      getbankDetail: "banklist/fetchBankByid",
      createHotel: "hotel/createHotel",
      updateHotelInfo: "hotel/updateHotelInfo",
      updateHotelLocation: "hotel/updateHotelLocation",
      updateAppStyle: "hotel/updateAppStyle",
      deleteHotel: "hotel/deleteHotel",
      updateHotelStatus: "hotel/updateHotelStatus",
      fetchHotelList: "hotel/fetchHotelList",
    }),
    async changeHotelStatus(hotel) {
      try {
        await this.updateHotelStatus({
          hotel_id: hotel.hotel_id,
          is_active: hotel.is_active,
        });
        this.snackBarMsg = "Hotel status updated successfully!";
      } catch (error) {
        this.snackBarMsg = "Failed to update hotel status.";
        hotel.is_active = !hotel.is_active; // Revert the change
      }
      this.errSnackbar = true;
    },
    async getData() {
      this.loadingMessage = true;
      try {
        await this.fetchHotelList();
      } catch (error) {
        // Handle error
        this.snackBarMsg = "Failed to fetch hotel list.";
        this.errSnackbar = true;
      } finally {
        this.loadingMessage = false;
      }
    },
    statusClass(status) {
      return {
        1: "badge_status--active",
        2: "badge_status--inactive",
        3: "badge_status--reject",
        4: "badge_status--delete",
        5: "badge_status--edit",
      }[status];
    },
    statusText(status) {
      return {
        1: "Pending",
        2: "Approve",
        3: "Reject",
        4: "Delete",
        5: "Edit document",
      }[status];
    },
    openCreateDialog() {
      this.selectedHotel = {};
      this.createDialog = true;
    },
    openEditDialog(hotel) {
      this.selectedHotel = hotel;
      this.editDialog = true;
    },
    openCommissionDialog(hotel) {
      this.selectedHotel = hotel;
      this.setComissionDialog = true;
    },
    async doUpdateHotelInfo(payload) {
      const hotel = payload.data;
      const body = {
        hotel_id: hotel.hotel_id,
        name: hotel.name,
        description: hotel.description,
        star_rating: hotel.star_rating,
        contact_email: hotel.contact_email,
        contact_phone: hotel.contact_phone,
        website: hotel.website,
      };
      const response = await this.updateHotelInfo(body);
      if (response && response.message === "Hotel updated successfully") {
        payload.done();
        this.editDialog = false;
        this.snackBarMsg = "Hotel updated successfully!";
      } else {
        payload.failed();
        this.snackBarMsg = "Failed to update hotel.";
      }
      this.errSnackbar = true;
    },
    async doUpdateHotelLocation(payload) {
      const location = payload.data.locations[0];
      const body = {
        location_id: location.location_id,
        hotel_id: payload.data.hotel_id,
        name: location.name,
        latitude: location.latitude,
        longitude: location.longitude,
        province: location.province,
      };
      const response = await this.updateHotelLocation(body);
      if (response && response.message === "Location updated successfully") {
        payload.done();
        this.editDialog = false;
        this.snackBarMsg = "Location updated successfully!";
      } else {
        payload.failed();
        this.snackBarMsg = "Failed to update location.";
      }
      this.errSnackbar = true;
    },
    async doUpdateAppStyle(payload) {
      const appStyle = payload.data.app_style;
      const body = {
        hotel_id: payload.data.hotel_id,
        primary_color: appStyle.primary_color,
        secondary_color: appStyle.secondary_color,
        hotel_logo: appStyle.hotel_logo,
        hotel_service_domain: appStyle.hotel_service_domain,
      };
      const response = await this.updateAppStyle(body);
      if (response && response.message === "App style updated successfully") {
        payload.done();
        this.editDialog = false;
        this.snackBarMsg = "App style updated successfully!";
      } else {
        payload.failed();
        this.snackBarMsg = "Failed to update app style.";
      }
      this.errSnackbar = true;
    },
    async doCreateHotel(payload) {
      const hotel = payload.data;
      try {
        const response = await this.createHotel(hotel);
        payload.done();
        this.createDialog = false;
        this.snackBarMsg = "Hotel created successfully!";
      } catch (error) {
        payload.failed();
        this.snackBarMsg = "Failed to create hotel.";
      }
      this.errSnackbar = true;
    },
    confirmDelete(hotel) {
      this.hotelToDelete = hotel;
      this.deleteDialog = true;
    },
    async deleteHotelItem() {
      this.isDeleting = true;
      const response = await this.deleteHotel({
        company_id: this.hotelToDelete.company_provider_wesmart_id,
      });
      if (response) {
        const index = this.hotelListData.findIndex(
          (item) =>
            item.company_provider_wesmart_id ===
            this.hotelToDelete.company_provider_wesmart_id
        );
        if (index !== -1) {
          this.hotelListData[index].company_provider_wesmart_status = 4;
        }
        this.snackBarMsg = "Hotel deleted successfully!";
      } else {
        this.snackBarMsg = "Failed to delete hotel.";
      }
      this.errSnackbar = true;
      this.deleteDialog = false;
      this.isDeleting = false;
    },
    moment,
  },
  created() {
    this.getData();
  },
};
</script>

<style>
.badge_status--active {
  background-color: #fbd200;
  color: #fff;
  font-weight: bold;
  padding: 5px 10px;
  border-radius: 12px;
}
.badge_status--inactive {
  background-color: #4caf50;
  color: #fff;
  padding: 5px 10px;
  border-radius: 12px;
}
.badge_status--reject {
  background-color: #fb3200;
  color: #fff;
  padding: 5px 10px;
  border-radius: 12px;
}
.badge_status--delete {
  background-color: #000000;
  color: #fff;
  padding: 5px 10px;
  border-radius: 12px;
}
.badge_status--edit {
  background-color: grey;
  color: #fff;
  padding: 5px 10px;
  border-radius: 12px;
  white-space: nowrap;
}
</style>
